<div class="m-portlet">
    <div class="m-portlet__head">
        <div class="m-portlet__head-progress">
            <mat-progress-bar mode="indeterminate" *ngIf="viewLoading"></mat-progress-bar>
        </div>
        <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
                <span class="m-portlet__head-icon m--hide">
                    <i class="la la-gear"></i>
                </span>
                <h3 class="m-portlet__head-text">
                    {{data.title}}
                </h3>
            </div>
        </div>
    </div>
    <div class="m-form">
        <div class="m-portlet__body">
            <div class="form-group m-form__group row">
                <div class="col-lg-12">
                    <div [innerHTML]="data.description"></div>
                </div>
            </div>
        </div>
        <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit text-right">
            <div class="m-form__actions m-form__actions--sm">
                <button  *ngIf="data.description != 'Yeni Fatura bulunmamaktadır.' && data.title != 'Seçim Yapmadınız!'"
				mat-raised-button (click)="onYesClick()" color="primary" cdkFocusInitial
                    [disabled]="viewLoading">Evet</button>&nbsp;
                <button *ngIf="data.description != 'Yeni Fatura bulunmamaktadır.' && data.title != 'Seçim Yapmadınız!'" mat-raised-button color="warn" (click)="onNoClick()">Hayır</button>
                <button *ngIf="data.description == 'Yeni Fatura bulunmamaktadır.' || data.title == 'Seçim Yapmadınız!'" mat-raised-button color="warn" (click)="onNoClick()">Kapat</button>
            </div>
        </div>
    </div>
</div>
